module.exports = __webpack_public_path__ + "static/media/cyber2.29126c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cyber2.jpg
// module id = 184
// module chunks = 0